/* eslint-disable react/prop-types */
import React from 'react';
import GenericButton from './GenericButton';
import { useSelector } from 'react-redux';

/**
 * @param props.title
 * @param props.handleLearnMore
 * @param props.isVisible
 * @param props.treatmentType
 * @param props.treatmentGroup
 * @param props.isLearnMore
 * @param props.disabled
 */
const SubStep = props => {
    const labels = useSelector(state => state.main.labels);
    const isLearnMoreModalOpen = useSelector(state => state.main.isLearnMoreModalOpen);

    return props.isVisible === undefined || props.isVisible ? (
        <div key={props.id} id={props.id} name={props.id} className="substep">
            <div className="substep-header">
                <div className="substep-title">{props.title}</div>
                {!props.isLearnMore && (
                    <div className="substep-learn-more">
                        <GenericButton
                            className="border-button"
                            handleClick={() => {
                                props.handleLearnMore(props.treatmentType, props.treatmentGroup);
                            }}
                            title="Learn more"
                            tabIndex={isLearnMoreModalOpen ? '-1' : '0'}
                            dataElementId={'X_X_LensPanel_Treatment-LearnMoreOpen'}
                            disabled={props.disabled}
                        >
                            {labels.learnMore}
                        </GenericButton>
                    </div>
                )}
            </div>
            <div className="substep-content">{props.children}</div>
        </div>
    ) : null;
};

export default SubStep;
